import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AnimatePresence, motion } from "framer-motion";

import { PackageOpen, PackagePlus, Package, CookingPot } from 'lucide-react';

import PanelDev from '../panels/dev/PanelDev';

import PanelInventory from 'panels/inventory/PanelInventory';
import PanelInventoryAdjList from 'panels/inventory/PanelInventoryAdjList';
import PanelInventoryAdjAdd from 'panels/inventory/PanelInventoryAdjAdd';
import PanelItem from 'panels/inventory/PanelItem';
import PanelItemAdd from 'panels/inventory/PanelItemAdd';
import PanelBom from 'panels/inventory/PanelBom';
import PanelBomAdd from 'panels/inventory/PanelBomAdd';

export default function LayoutInventory() {

    const itemVariants = {
        closed: { opacity: 0 },
        open: { opacity: 1 }
    };

    const { page } = useParams();

    const [isOpen, setIsOpen] = useState(true);

    const navigate = useNavigate();

    const changeNav = (link) => {
        navigate(`/${link}`);
        setIsOpen(true);
    }

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    const closeMenu = () => {
        setIsOpen(false);
    }

    const openMenu = () => {
        setIsOpen(true);
    }

    return (
        <div className='w-full min-h-screen grid grid-cols-12 gap-2'>
            <AnimatePresence>
                {
                    isOpen && <motion.div initial={{ flexBasis: 0, opacity: 0 }} animate={{ flexBasis: '100%', opacity: 1 }} exit={{ flexBasis: 0, opacity: 0, transition: { delay: 0.2, duration: 0.3 } }} className="col-span-2 h-screen bg-slate-100">
                        <motion.h1 initial="closed" animate="open" exit="closed" variants={itemVariants} className="text-2xl font-medium px-1 mx-2 py-1 my-2 rounded">Orders</motion.h1>
                        <motion.ul initial="closed" animate="open" exit="closed" variants={itemVariants} className="w-full flex flex-col items-start space-y-2 px-2">
                            <li className={`w-full p-1 cursor-pointer text-base hover:bg-gray-200 rounded flex items-center ${page === 'inventory' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('inventory') }}>
                                <PackageOpen size={20} className='mr-2' /> Inventory Stock
                            </li>
                            <li className={`w-full p-1 cursor-pointer text-base hover:bg-gray-200 rounded flex items-center ${page === 'invAdj' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('invAdj') }}>
                                <PackagePlus size={20} className='mr-2' /> Inventory Adjustments
                            </li>
                            <li className={`w-full p-1 cursor-pointer text-base hover:bg-gray-200 rounded flex items-center ${page === 'invItems' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('invItems') }}>
                                <Package size={20} className='mr-2' /> Inventory items
                            </li>
                            <li className={`w-full p-1 cursor-pointer text-base hover:bg-gray-200 rounded flex items-center ${page === 'bom' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('bom') }}>
                                <CookingPot size={20} className='mr-2' /> Bill of Materials
                            </li>
                        </motion.ul>
                    </motion.div>
                }
            </AnimatePresence>
            <div className={`h-screen ${isOpen ? "col-span-10" : "col-span-12"}`}>
                {
                    (() => {
                        switch (page) {
                            case 'inventory':
                                return (<PanelInventory onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'invAdj':
                                return (<PanelInventoryAdjList onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'invAdjAdd':
                                return (<PanelInventoryAdjAdd onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'invItems':
                                return (<PanelItem onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'itemAdd':
                                return (<PanelItemAdd onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'bom':
                                return (<PanelBom onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'bomAdd':
                                return (<PanelBomAdd onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </div>
    )
}
